import * as turf from '@turf/turf'

function mapboxBoundsToBbox (bounds) {
  return [bounds.getWest(), bounds.getSouth(), bounds.getEast(), bounds.getNorth()]
}
function pointsWithinBounds (geoJSON, bounds) {
  return turf.pointsWithinPolygon(geoJSON, turf.bboxPolygon(mapboxBoundsToBbox(bounds)))
}
export {
  pointsWithinBounds
}
